<template>
  <v-card class="recipe-options-card" elevation="8">
    <v-container :class="isMobile ? 'pa-2' : 'pa-4'">
      <!-- Información del paciente -->
      <div :class="isMobile ? 'mb-2' : 'mb-3'">
        <v-card class="patient-card" variant="tonal" color="blue-grey">
          <v-card-text :class="isMobile ? 'pa-2' : 'pa-3'">
            <div class="d-flex align-center">
              <v-avatar
                color="primary"
                :size="isMobile ? '32' : '36'"
                :class="isMobile ? 'mr-2' : 'mr-3'"
              >
                <v-icon color="white" :size="isMobile ? '16' : '18'"
                  >mdi-account</v-icon
                >
              </v-avatar>
              <div class="flex-grow-1">
                <div
                  :class="isMobile ? 'text-h6' : 'text-subtitle-1'"
                  class="font-weight-bold text-primary mb-1"
                >
                  {{ paciente }}
                </div>
                <div
                  :class="isMobile ? 'text-body-2' : 'text-caption'"
                  class="text-grey-darken-1"
                >
                  <v-icon :size="isMobile ? '14' : '12'" class="mr-1"
                    >mdi-clipboard-text</v-icon
                  >
                  {{
                    isMobile
                      ? getMensajePacienteHeaderMobile()
                      : getMensajePacienteHeader()
                  }}
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <!-- Título de opciones -->
      <div class="text-center" :class="isMobile ? 'mb-4' : 'mb-3'">
        <h3
          :class="isMobile ? 'text-h6' : 'text-subtitle-1'"
          class="text-grey-darken-2 font-weight-bold"
        >
          {{ isMobile ? `Enviar ${getTipoPrescripcionTextoCorto()}` : "Seleccione las opciones de envío" }}
        </h3>
        <div v-if="isMobile" class="text-body-2 text-grey mt-1">
          Elija una o varias opciones
        </div>
        <div v-else class="text-caption text-grey">
          Puede elegir una o varias opciones según necesite
        </div>
      </div>

      <v-row class="options-container">
        <!-- Opción WhatsApp -->
        <v-col cols="12" class="option-col">
          <v-card
            :class="[
              'option-card',
              'whatsapp-card',
              { completed: sentStatus.whatsapp },
            ]"
            :elevation="sentStatus.whatsapp ? 6 : 3"
            @click="!sentStatus.whatsapp && sendTo(1)"
            :style="{ cursor: sentStatus.whatsapp ? 'default' : 'pointer' }"
          >
            <v-card-text :class="isMobile ? 'pa-4' : 'pa-2'">
              <div v-if="isMobile" class="mobile-option-layout">
                <!-- Header con icono y título -->
                <div class="d-flex align-center mb-3">
                  <div class="mobile-icon-container whatsapp-icon mr-4">
                    <v-icon
                      :color="sentStatus.whatsapp ? '#4CAF50' : '#25D366'"
                      size="28"
                      class="option-icon"
                    >
                      {{
                        sentStatus.whatsapp
                          ? "mdi-check-circle"
                          : "mdi-whatsapp"
                      }}
                    </v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-h6 font-weight-bold mb-1">WhatsApp</div>
                    <div class="text-body-2 text-grey-darken-1">
                      <v-icon size="14" class="mr-1">mdi-phone</v-icon>
                      {{ telefono }}
                    </div>
                  </div>
                </div>

                <!-- Descripción -->
                <div class="mb-4">
                  <div class="text-body-2 text-grey-darken-2">
                    {{
                      sentStatus.whatsapp
                        ? "✅ Mensaje enviado exitosamente"
                        : `📱 Enviar enlace de la ${getTipoPrescripcionTextoCorto()} por WhatsApp`
                    }}
                  </div>
                </div>

                <!-- Botón de acción grande -->
                <v-btn
                  :color="sentStatus.whatsapp ? 'success' : '#25D366'"
                  :disabled="sentStatus.whatsapp"
                  variant="flat"
                  size="large"
                  block
                  class="mobile-action-btn"
                  @click.stop="sendTo(1)"
                >
                  <v-icon size="20" class="mr-2">
                    {{ sentStatus.whatsapp ? "mdi-check" : "mdi-send" }}
                  </v-icon>
                  {{
                    sentStatus.whatsapp
                      ? "Enviado por WhatsApp"
                      : "Enviar por WhatsApp"
                  }}
                </v-btn>
              </div>
              <v-row v-else align="center" no-gutters>
                <v-col cols="2" class="text-center">
                  <div class="icon-container whatsapp-icon">
                    <v-icon
                      :color="sentStatus.whatsapp ? '#4CAF50' : '#25D366'"
                      size="24"
                      class="option-icon"
                    >
                      {{
                        sentStatus.whatsapp
                          ? "mdi-check-circle"
                          : "mdi-whatsapp"
                      }}
                    </v-icon>
                  </div>
                </v-col>
                <v-col cols="7" class="option-content">
                  <div class="text-subtitle-1 font-weight-medium">WhatsApp</div>
                  <div
                    class="text-caption text-grey-darken-1 d-flex align-center"
                  >
                    <v-icon size="12" class="mr-1">mdi-phone</v-icon>
                    {{ telefono }}
                  </div>
                  <div
                    class="text-caption text-grey"
                    style="font-size: 11px !important"
                  >
                    {{
                      sentStatus.whatsapp
                        ? "Mensaje enviado exitosamente"
                        : `Enviar enlace por WhatsApp`
                    }}
                  </div>
                </v-col>
                <v-col cols="3" class="text-right">
                  <v-btn
                    :color="sentStatus.whatsapp ? 'success' : '#25D366'"
                    :disabled="sentStatus.whatsapp"
                    variant="flat"
                    size="small"
                    class="action-btn-compact"
                    @click.stop="sendTo(1)"
                  >
                    <v-icon size="14" class="mr-1">
                      {{ sentStatus.whatsapp ? "mdi-check" : "mdi-send" }}
                    </v-icon>
                    {{ sentStatus.whatsapp ? "Enviado" : "Enviar" }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Opción Email -->
        <v-col cols="12" class="option-col">
          <v-card
            :class="[
              'option-card',
              'email-card',
              { completed: sentStatus.email },
            ]"
            :elevation="sentStatus.email ? 6 : 3"
            @click="
              !sentStatus.email &&
                !loadingSendEmailBtn &&
                !isEditingEmail &&
                sendTo(3)
            "
            :style="{
              cursor:
                sentStatus.email || loadingSendEmailBtn || isEditingEmail
                  ? 'default'
                  : 'pointer',
            }"
          >
            <v-card-text :class="isMobile ? 'pa-4' : 'pa-2'">
              <div v-if="isMobile" class="mobile-option-layout">
                <!-- Header con icono y título -->
                <div class="d-flex align-center mb-3">
                  <div class="mobile-icon-container email-icon mr-4">
                    <v-icon
                      :color="sentStatus.email ? '#4CAF50' : '#1976D2'"
                      size="28"
                      class="option-icon"
                    >
                      {{ sentStatus.email ? "mdi-check-circle" : "mdi-email" }}
                    </v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-h6 font-weight-bold mb-1">Email</div>
                    <div class="text-body-2 text-grey-darken-1">
                      <div class="d-flex align-center">
                        <v-icon size="14" class="mr-1">mdi-at</v-icon>
                        <span v-if="!isEditingEmail">{{ editableEmail }}</span>
                        <v-text-field
                          v-else
                          v-model="editableEmail"
                          dense
                          hide-details
                          single-line
                          variant="outlined"
                          type="email"
                          class="email-edit-field-mobile"
                          @keyup.enter="finishEditingEmail"
                          @blur="finishEditingEmail"
                          @click.stop
                          style="
                            font-size: 0.9rem;
                            margin-left: 4px;
                            margin-right: 8px;
                          "
                        ></v-text-field>
                        <!-- Botón de editar inmediatamente al lado del email -->
                        <v-tooltip text="Editar destinatario">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              v-if="!isEditingEmail"
                              v-bind="props"
                              icon
                              size="small"
                              variant="text"
                              color="primary"
                              class="ml-1 email-edit-btn"
                              tabindex="-1"
                              @click.stop="startEditingEmail"
                            >
                              <v-icon size="16">mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Descripción -->
                <div class="mb-4">
                  <div class="text-body-2 text-grey-darken-2">
                    {{
                      sentStatus.email
                        ? "✅ Correo enviado exitosamente. Puede reenviar si es necesario"
                        : `📧 Enviar ${getTipoPrescripcionTextoCorto()} por correo electrónico`
                    }}
                  </div>
                </div>

                <!-- Botón de acción grande -->
                <v-btn
                  :color="sentStatus.email ? 'success' : 'primary'"
                  :disabled="!isValidEmail"
                  :loading="loadingSendEmailBtn"
                  variant="flat"
                  size="large"
                  block
                  class="mobile-action-btn"
                  @click.stop="sendTo(3)"
                >
                  <v-icon size="20" class="mr-2">
                    {{ sentStatus.email ? "mdi-refresh" : "mdi-send" }}
                  </v-icon>
                  {{
                    sentStatus.email ? "Reenviar por Email" : "Enviar por Email"
                  }}
                </v-btn>
              </div>
              <v-row v-else align="center" no-gutters>
                <v-col cols="2" class="text-center">
                  <div class="icon-container email-icon">
                    <v-icon
                      :color="sentStatus.email ? '#4CAF50' : '#1976D2'"
                      size="24"
                      class="option-icon"
                    >
                      {{ sentStatus.email ? "mdi-check-circle" : "mdi-email" }}
                    </v-icon>
                  </div>
                </v-col>
                <v-col cols="7" class="option-content">
                  <div class="text-subtitle-1 font-weight-medium">Email</div>
                  <div class="text-caption text-grey-darken-1">
                    <div class="d-flex align-center">
                      <v-icon size="12" class="mr-1">mdi-at</v-icon>
                      <span v-if="!isEditingEmail">{{ editableEmail }}</span>
                      <v-text-field
                        v-else
                        v-model="editableEmail"
                        dense
                        hide-details
                        single-line
                        variant="outlined"
                        type="email"
                        class="email-edit-field-desktop-expanded"
                        @keyup.enter="finishEditingEmail"
                        @blur="finishEditingEmail"
                        @click.stop
                        style="
                          font-size: 0.75rem;
                          margin-left: 4px;
                          margin-right: 8px;
                        "
                      ></v-text-field>
                      <!-- Botón de editar inmediatamente al lado del email -->
                      <v-btn
                        v-if="!isEditingEmail"
                        icon
                        size="x-small"
                        variant="text"
                        color="primary"
                        class="email-edit-btn mx-1"
                        style="min-width: auto; height: 20px; width: 20px"
                        tabindex="-1"
                        @click.stop="startEditingEmail"
                      >
                        <v-tooltip text="Editar destinatario">
                          <template v-slot:activator="{ props }">
                            <v-icon size="12" v-bind="props">mdi-pencil</v-icon>
                          </template>
                        </v-tooltip>
                      </v-btn>
                    </div>
                  </div>
                  <div
                    class="text-caption text-grey"
                    style="font-size: 11px !important"
                  >
                    <span>{{
                      sentStatus.email
                        ? "Correo enviado exitosamente. Puede reenviar"
                        : `Enviar ${getTipoPrescripcionTextoCorto()} por correo electrónico`
                    }}</span>
                  </div>
                </v-col>
                <v-col cols="3" class="text-right">
                  <v-btn
                    :color="sentStatus.email ? 'success' : 'primary'"
                    :disabled="!isValidEmail"
                    :loading="loadingSendEmailBtn"
                    variant="flat"
                    size="small"
                    class="action-btn-compact"
                    @click.stop="sendTo(3)"
                  >
                    <v-icon size="14" class="mr-1">
                      {{ sentStatus.email ? "mdi-refresh" : "mdi-send" }}
                    </v-icon>
                    {{ sentStatus.email ? "Reenviar" : "Enviar" }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Opción PDF -->
        <v-col cols="12" class="option-col">
          <v-card
            :class="['option-card', 'pdf-card', { completed: sentStatus.pdf }]"
            :elevation="sentStatus.pdf ? 6 : 3"
            @click="sendTo(2)"
            style="cursor: pointer"
          >
            <v-card-text :class="isMobile ? 'pa-4' : 'pa-2'">
              <div v-if="isMobile" class="mobile-option-layout">
                <!-- Header con icono y título -->
                <div class="d-flex align-center mb-3">
                  <div class="mobile-icon-container pdf-icon mr-4">
                    <v-icon
                      :color="sentStatus.pdf ? '#4CAF50' : '#F44336'"
                      size="28"
                      class="option-icon"
                    >
                      {{
                        sentStatus.pdf ? "mdi-check-circle" : "mdi-file-pdf-box"
                      }}
                    </v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-h6 font-weight-bold mb-1">
                      Imprimir PDF
                    </div>
                    <div class="text-body-2 text-grey-darken-1">
                      <v-icon size="14" class="mr-1">mdi-printer</v-icon>
                      Documento listo para imprimir
                    </div>
                  </div>
                </div>

                <!-- Descripción -->
                <div class="mb-4">
                  <div class="text-body-2 text-grey-darken-2">
                    {{
                      sentStatus.pdf
                        ? "✅ PDF abierto anteriormente"
                        : `📄 Abrir ${getTipoPrescripcionTextoCorto()} en formato PDF para imprimir`
                    }}
                  </div>
                </div>

                <!-- Botón de acción grande -->
                <v-btn
                  :color="sentStatus.pdf ? 'success' : '#F44336'"
                  variant="flat"
                  size="large"
                  block
                  class="mobile-action-btn"
                  @click.stop="sendTo(2)"
                >
                  <v-icon size="20" class="mr-2">
                    {{ sentStatus.pdf ? "mdi-refresh" : "mdi-download" }}
                  </v-icon>
                  {{ sentStatus.pdf ? "Reabrir PDF" : "Abrir PDF" }}
                </v-btn>
              </div>
              <v-row v-else align="center" no-gutters>
                <v-col cols="2" class="text-center">
                  <div class="icon-container pdf-icon">
                    <v-icon
                      :color="sentStatus.pdf ? '#4CAF50' : '#F44336'"
                      size="24"
                      class="option-icon"
                    >
                      {{
                        sentStatus.pdf ? "mdi-check-circle" : "mdi-file-pdf-box"
                      }}
                    </v-icon>
                  </div>
                </v-col>
                <v-col cols="7" class="option-content">
                  <div class="text-subtitle-1 font-weight-medium">
                    Imprimir PDF
                  </div>
                  <div
                    class="text-caption text-grey-darken-1 d-flex align-center"
                  >
                    <v-icon size="12" class="mr-1">mdi-printer</v-icon>
                    Documento listo para imprimir
                  </div>
                  <div
                    class="text-caption text-grey"
                    style="font-size: 11px !important"
                  >
                    {{
                      sentStatus.pdf
                        ? "PDF abierto anteriormente"
                        : `Abrir ${getTipoPrescripcionTextoCorto()} en formato PDF`
                    }}
                  </div>
                </v-col>
                <v-col cols="3" class="text-right">
                  <v-btn
                    :color="sentStatus.pdf ? 'success' : '#F44336'"
                    variant="flat"
                    size="small"
                    class="action-btn-compact"
                    @click.stop="sendTo(2)"
                  >
                    <v-icon size="14" class="mr-1">
                      {{ sentStatus.pdf ? "mdi-refresh" : "mdi-download" }}
                    </v-icon>
                    {{ sentStatus.pdf ? "Reabrir" : "Abrir" }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Mensaje de confirmación compacto -->
      <div v-if="hasAnySent" :class="isMobile ? 'mt-2' : 'mt-3'">
        <v-alert
          type="success"
          variant="tonal"
          density="compact"
          class="text-center"
        >
          <div class="d-flex align-center justify-center">
            <div
              :class="isMobile ? 'text-caption' : 'text-caption'"
              class="font-weight-medium"
            >
              {{ isMobile ? "¡Enviado!" : `¡${getTipoPrescripcionTextoCorto().charAt(0).toUpperCase() + getTipoPrescripcionTextoCorto().slice(1)} procesada!` }}
              {{ getSentOptionsText() }}
            </div>
          </div>
        </v-alert>
      </div>
    </v-container>

    <!-- Footer compacto -->
    <v-card-actions :class="isMobile ? 'pa-2 pt-1' : 'pa-3 pt-2'">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        variant="flat"
        :size="isMobile ? 'small' : 'small'"
        :class="isMobile ? 'px-4' : 'px-6'"
        @click="closeModal(true)"
        id="btn-close"
      >
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SendRecipe",
  props: {
    link: { type: String, required: true },
    telefono: { type: String, required: true },
    email: { type: String, required: true },
    paciente: { type: String, required: true },
    solicitudId: { type: Number, required: true },
    tipoPrescripcion: { type: String, default: "medicamentos" }, // "medicamentos", "dispositivos", "general"
  },
  data() {
    return {
      loadingSendEmailBtn: false,
      editableEmail: this.email, // Copia editable del email
      lastValidEmail: this.email, // Último email válido
      isEditingEmail: false, // Controla si está en modo edición
      sentStatus: {
        whatsapp: false,
        email: false,
        pdf: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
    }),
    hasAnySent() {
      return (
        this.sentStatus.whatsapp || this.sentStatus.email || this.sentStatus.pdf
      );
    },
    isValidEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.editableEmail);
    },
  },
  watch: {
    email(newValue) {
      this.editableEmail = newValue;
      this.lastValidEmail = newValue;
    },
  },

  methods: {
    ...mapActions({
      sendRecipeByEmail: "solicitud/sendRecipeByEmail",
      insertLogSolicitud: "solicitud/insertLogSolicitud",
      setAlert: "user/setAlert",
    }),
    async sendTo(to) {
      switch (to) {
        case 1: { // Wpp
          try {
            const mensaje = this.getMensajeWhatsApp();

            const whatsappUrl = `https://api.whatsapp.com/send?phone=${
              this.telefono
            }&text=${encodeURIComponent(mensaje)}`;
            window.open(whatsappUrl);

            // Marcar como enviado
            this.sentStatus.whatsapp = true;
            this.setAlert({
              type: "success",
              message: `Se abrió WhatsApp para enviar la ${this.getTipoPrescripcionTextoCorto()}.`,
            });
          } catch (error) {
            console.error(error);
            this.setAlert({
              type: "error",
              message: "Error al abrir WhatsApp.",
            });
          }
          break;
        }
        case 2: { // Pdf
          try {
            window.open(this.link, "_blank");
            // Marcar como abierto
            this.sentStatus.pdf = true;
            
            // Insertar log de impresión exitosa
            await this.insertLogSolicitud({
              logSolicitudPayload: this.link,
              logSolicitudResponse: "OK",
              servicioId: 4,
              observacion: `${this.getTipoPrescripcionTexto().charAt(0).toUpperCase() + this.getTipoPrescripcionTexto().slice(1)} impresa en formato PDF`,
              solicitudId: this.solicitudId
            });
            
            this.setAlert({
              type: "success",
              message: "PDF abierto para imprimir.",
            });
          } catch (error) {
            console.error(error);
            
            // Insertar log de error en impresión
            try {
              await this.insertLogSolicitud({
                logSolicitudPayload: this.link,
                logSolicitudResponse: "ERROR",
                servicioId: 4,
                observacion: `Error al imprimir PDF: ${error.message}`,
                solicitudId: this.solicitudId
              });
            } catch (logError) {
              console.error("Error al registrar log:", logError);
            }
            
            this.setAlert({
              type: "error",
              message: "Error al abrir el PDF.",
            });
          }
          break;
        }
        case 3: { // Mail
          if (!this.isValidEmail) {
            this.setAlert({
              type: "error",
              message: "Por favor ingrese un email válido.",
            });
            return;
          }
          this.loadingSendEmailBtn = true;
          const bodyToSend = this.getMensajeEmailHTML();
          try {
            const data = {
              toEmail: this.editableEmail,
              subject: this.getSubjectEmail(),
              body: bodyToSend,
            };
            const response = await this.sendRecipeByEmail(data);
            if (response.status === 200) {
              // Verificar si es reenvío antes de marcar como enviado
              const isResend = this.sentStatus.email;
              this.sentStatus.email = true;
              
              // Insertar log de envío exitoso por email
              await this.insertLogSolicitud({
                logSolicitudPayload: bodyToSend,
                logSolicitudResponse: "OK",
                servicioId: 5,
                observacion: `${this.getTipoPrescripcionTexto().charAt(0).toUpperCase() + this.getTipoPrescripcionTexto().slice(1)} enviada por email a: ${this.editableEmail}`,
                solicitudId: this.solicitudId
              });
              
              this.setAlert({
                type: "success",
                message: isResend
                  ? `${this.getTipoPrescripcionTexto().charAt(0).toUpperCase() + this.getTipoPrescripcionTexto().slice(1)} reenviada exitosamente.`
                  : `${this.getTipoPrescripcionTexto().charAt(0).toUpperCase() + this.getTipoPrescripcionTexto().slice(1)} enviada al mail ingresado del afiliado.`,
              });
            }
          } catch (error) {
            console.error(error);
            
            // Insertar log de error en envío por email
            try {
              await this.insertLogSolicitud({
                logSolicitudPayload: bodyToSend,
                logSolicitudResponse: "ERROR",
                servicioId: 5,
                observacion: `Error al enviar email a: ${this.editableEmail} - ${error.message}`,
                solicitudId: this.solicitudId
              });
            } catch (logError) {
              console.error("Error al registrar log:", logError);
            }
            
            this.setAlert({
              type: "error",
              message: "Error al enviar el email.",
            });
          }
          this.loadingSendEmailBtn = false;
          break;
        }
        default:
          break;
      }
    },
    getSentOptionsText() {
      const options = [];
      if (this.sentStatus.whatsapp) options.push("WhatsApp");
      if (this.sentStatus.email) options.push("Email");
      if (this.sentStatus.pdf) options.push("Impresión");

      if (options.length === 0) return "";
      if (options.length === 1) return `Enviado por ${options[0]}`;
      if (options.length === 2) {
        // Usar "e" si la segunda opción empieza con "i" o vocal acentuada
        const conjunction = options[1].toLowerCase().match(/^[iíù]/) ? "e" : "y";
        return `Enviado por ${options[0]} ${conjunction} ${options[1]}`;
      }
      return `Enviado por ${options[0]}, ${options[1]} e ${options[2]}`;
    },
    closeModal(reload) {
      this.$emit("closeModal", reload);
    },
    resetEmailField() {
      this.editableEmail = this.email;
      this.lastValidEmail = this.email;
      this.isEditingEmail = false;
    },
    startEditingEmail() {
      this.isEditingEmail = true;
      this.$nextTick(() => {
        // Buscar el input y enfocarlo
        const emailInput = this.$el.querySelector(
          ".email-edit-field-mobile input, .email-edit-field-desktop-expanded input"
        );
        if (emailInput) {
          emailInput.focus();
          emailInput.select();
        }
      });
    },
    finishEditingEmail() {
      // Si el email no es válido, restaurar el último email válido
      if (!this.isValidEmail) {
        this.editableEmail = this.lastValidEmail;
        this.setAlert({
          type: "warning",
          message: "Email inválido. Se restauró el email anterior.",
        });
      } else {
        // Si es válido, guardarlo como último email válido
        this.lastValidEmail = this.editableEmail;
      }
      this.isEditingEmail = false;
    },
    // Métodos para generar textos dinámicos según tipo de prescripción
    getTipoPrescripcionTexto() {
      switch (this.tipoPrescripcion) {
        case "dispositivos":
          return "prescripción de dispositivos";
        case "medicamentos":
          return "receta electrónica";
        case "general":
        default:
          return "prescripción";
      }
    },
    getTipoPrescripcionTextoCorto() {
      switch (this.tipoPrescripcion) {
        case "dispositivos":
          return "prescripción";
        case "medicamentos":
          return "receta";
        case "general":
        default:
          return "prescripción";
      }
    },
    getSubjectEmail() {
      switch (this.tipoPrescripcion) {
        case "dispositivos":
          return "Nueva prescripción de dispositivos";
        case "medicamentos":
          return "Nueva receta";
        case "general":
        default:
          return "Nueva prescripción";
      }
    },
    getMensajePacienteHeader() {
      switch (this.tipoPrescripcion) {
        case "dispositivos":
          return "Prescripción de dispositivos lista para enviar";
        case "medicamentos":
          return "Receta electrónica lista para enviar";
        case "general":
        default:
          return "Prescripción lista para enviar";
      }
    },
    getMensajePacienteHeaderMobile() {
      switch (this.tipoPrescripcion) {
        case "dispositivos":
          return "Prescripción lista para enviar";
        case "medicamentos":
          return "Receta lista para enviar";
        case "general":
        default:
          return "Prescripción lista para enviar";
      }
    },
    getMensajeWhatsApp() {
      const tipoPrescripcion = this.getTipoPrescripcionTexto();
      return `Su ${tipoPrescripcion} ha sido emitida y está disponible para su consulta. Puede acceder a su ${tipoPrescripcion.includes("receta") ? "receta" : "prescripción"} a través del siguiente enlace:

${this.link}`;
    },
    getMensajeEmailHTML() {
      const tipoPrescripcion = this.getTipoPrescripcionTexto();
      const tipoPrescripcionGeneral = tipoPrescripcion.includes("receta") ? "receta" : "prescripción";
      
      return `
          <!DOCTYPE html>
                                <html>
                                <head>
                                    <style>
                                        body {
                                            font-family: Arial, sans-serif;
                                        }
                                        .container {
                                            max-width: 600px;
                                            margin: auto;
                                            padding: 20px;
                                            border: 1px solid #dcdcdc;
                                            border-radius: 5px;
                                        }
                                        .header {
                                            background-color: #4CAF50;
                                            color: white;
                                            padding: 10px;
                                            text-align: center;
                                        }
                                        .content {
                                            margin-top: 20px;
                                        }
                                        .content p {
                                            line-height: 1.6;
                                        }
                                        .footer {
                                            margin-top: 20px;
                                            font-size: 0.9em;
                                            color: #888888;
                                        }
                                        .link {
                                            color: #0066cc;
                                            text-decoration: none;
                                        }
                                    </style>
                                </head>
                                <body>
                                    <div class='container'>
                                        <div class='header'>
                                            <h1>¡Saludos ${this.paciente}!</h1>
                                        </div>
                                        <div class='content'>
                                            <p>Su ${tipoPrescripcion} ha sido proporcionada por su médico.</p>
                                            <p>Puede acceder a su ${tipoPrescripcionGeneral} a través del siguiente enlace:</p>
                                            <p><a href='${this.link}' class='link'>${this.link}</a></p>
                                        </div>
                                        <div class='footer'>
                                            <p>Este es un mensaje automático, por favor no responder.</p>
                                        </div>
                                    </div>
                                </body>
                                </html>
                            `;
    },
  },
};
</script>

<style scoped>
/* Header con gradiente */
.header-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px 4px 0 0;
}

/* Card principal */
.recipe-options-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

/* Card del paciente */
.patient-card {
  border-radius: 12px !important;
  border: 2px solid rgba(25, 118, 210, 0.2);
  transition: all 0.3s ease;
}

.patient-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.15);
}

/* Contenedor de opciones */
.options-container {
  gap: 6px;
}

.option-col {
  padding: 3px;
}

/* Cards de opciones */
.option-card {
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.option-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.option-card:hover::before {
  left: 100%;
}

.option-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.12);
}

/* WhatsApp Card */
.whatsapp-card {
  border-color: rgba(37, 211, 102, 0.3);
  background: linear-gradient(
    135deg,
    rgba(37, 211, 102, 0.05) 0%,
    rgba(37, 211, 102, 0.02) 100%
  );
}

.whatsapp-card.completed {
  border-color: rgba(76, 175, 80, 0.5);
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.1) 0%,
    rgba(76, 175, 80, 0.05) 100%
  );
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

/* Email Card */
.email-card {
  border-color: rgba(25, 118, 210, 0.3);
  background: linear-gradient(
    135deg,
    rgba(25, 118, 210, 0.05) 0%,
    rgba(25, 118, 210, 0.02) 100%
  );
}

.email-card.completed {
  border-color: rgba(76, 175, 80, 0.5);
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.1) 0%,
    rgba(76, 175, 80, 0.05) 100%
  );
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

/* PDF Card */
.pdf-card {
  border-color: rgba(244, 67, 54, 0.3);
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 0.05) 0%,
    rgba(244, 67, 54, 0.02) 100%
  );
}

.pdf-card.completed {
  border-color: rgba(76, 175, 80, 0.5);
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.1) 0%,
    rgba(76, 175, 80, 0.05) 100%
  );
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

/* Iconos de opciones */
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
}

.whatsapp-icon {
  background: linear-gradient(
    135deg,
    rgba(37, 211, 102, 0.1) 0%,
    rgba(37, 211, 102, 0.2) 100%
  );
}

.email-icon {
  background: linear-gradient(
    135deg,
    rgba(25, 118, 210, 0.1) 0%,
    rgba(25, 118, 210, 0.2) 100%
  );
}

.pdf-icon {
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 0.1) 0%,
    rgba(244, 67, 54, 0.2) 100%
  );
}

.option-icon {
  transition: all 0.3s ease;
}

.option-card:hover .option-icon {
  transform: scale(1.1);
}

.completed .icon-container {
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.2) 0%,
    rgba(76, 175, 80, 0.3) 100%
  );
}

/* Contenido de opciones */
.option-content {
  padding-left: 8px;
}

/* Botones de acción */
.action-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-width: 100px;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Botones compactos */
.action-btn-compact {
  border-radius: 6px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-width: 80px;
  font-size: 12px !important;
}

.action-btn-compact:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Botones móviles */
.action-btn-mobile {
  border-radius: 6px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-width: 70px;
  font-size: 11px !important;
}

.action-btn-mobile:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Layout móvil para opciones */
.mobile-option-layout {
  width: 100%;
  padding: 0;
}

/* Iconos móviles más grandes */
.mobile-icon-container {
  width: 56px !important;
  height: 56px !important;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

/* Botones de acción móviles */
.mobile-action-btn {
  height: 56px !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.mobile-action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
}

/* Estilo específico para iconos móviles WhatsApp */
.mobile-icon-container.whatsapp-icon {
  background: linear-gradient(
    135deg,
    rgba(37, 211, 102, 0.15) 0%,
    rgba(37, 211, 102, 0.25) 100%
  );
  border: 2px solid rgba(37, 211, 102, 0.3);
}

/* Estilo específico para iconos móviles Email */
.mobile-icon-container.email-icon {
  background: linear-gradient(
    135deg,
    rgba(25, 118, 210, 0.15) 0%,
    rgba(25, 118, 210, 0.25) 100%
  );
  border: 2px solid rgba(25, 118, 210, 0.3);
}

/* Estilo específico para iconos móviles PDF */
.mobile-icon-container.pdf-icon {
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 0.15) 0%,
    rgba(244, 67, 54, 0.25) 100%
  );
  border: 2px solid rgba(244, 67, 54, 0.3);
}

/* Completado en móvil */
.completed .mobile-icon-container {
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.2) 0%,
    rgba(76, 175, 80, 0.3) 100%
  ) !important;
  border: 2px solid rgba(76, 175, 80, 0.5) !important;
}

/* Mejoras de tipografía móvil */
.mobile-option-layout .text-h6 {
  line-height: 1.3;
  font-size: 1.25rem !important;
}

.mobile-option-layout .text-body-2 {
  line-height: 1.4;
  font-size: 0.9rem !important;
}

/* Espaciado móvil mejorado */
.mobile-option-layout .mb-3 {
  margin-bottom: 16px !important;
}

.mobile-option-layout .mb-4 {
  margin-bottom: 20px !important;
}

/* Alert de éxito compacto */
.v-alert.v-alert--density-compact {
  border-radius: 8px !important;
  animation: slideInUp 0.3s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animaciones para cards completadas */
.completed {
  animation: pulseGreen 0.4s ease-out;
}

@keyframes pulseGreen {
  0% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.3);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(76, 175, 80, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
}

/* Efectos de hover mejorados */
.option-card:hover {
  cursor: pointer;
}

.option-card:hover .icon-container {
  transform: scale(1.05);
}

/* Responsive Mobile */
@media (max-width: 600px) {
  .recipe-options-card {
    margin: 4px !important;
    border-radius: 16px !important;
    max-height: 90vh;
    overflow-y: auto;
  }

  /* Desktop icons en mobile */
  .icon-container {
    width: 32px;
    height: 32px;
  }

  .option-icon {
    font-size: 16px !important;
  }

  /* Botones compactos desktop en mobile */
  .action-btn-compact {
    min-width: 65px;
    font-size: 10px !important;
  }

  .action-btn-mobile {
    min-width: 65px;
    font-size: 10px !important;
  }

  .option-content {
    padding-left: 4px;
  }

  /* Card del paciente en mobile */
  .patient-card .v-avatar {
    width: 28px !important;
    height: 28px !important;
  }

  .patient-card .v-icon {
    font-size: 14px !important;
  }

  /* Layout móvil específico */
  .mobile-option-layout {
    padding: 0 !important;
  }

  .mobile-icon-container {
    width: 48px !important;
    height: 48px !important;
  }

  .mobile-action-btn {
    height: 52px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
  }

  .mobile-option-layout .text-h6 {
    font-size: 1.1rem !important;
  }

  .mobile-option-layout .text-body-2 {
    font-size: 0.8rem !important;
  }

  /* Espaciado en mobile */
  .options-container {
    gap: 8px !important;
  }

  .option-col {
    padding: 4px !important;
  }

  /* Cards más espaciadas en mobile */
  .option-card {
    margin-bottom: 8px;
  }

  /* Container principal en mobile */
  .recipe-options-card .v-container {
    padding: 16px !important;
  }

  /* Mejorar espaciado entre cards en mobile */
  .mobile-option-layout .mb-3 {
    margin-bottom: 12px !important;
  }

  .mobile-option-layout .mb-4 {
    margin-bottom: 16px !important;
  }

  /* Card del paciente en mobile */
  .patient-card {
    border-radius: 16px !important;
  }

  .patient-card .v-avatar {
    width: 36px !important;
    height: 36px !important;
  }

  .patient-card .v-icon {
    font-size: 18px !important;
  }
}

/* Mejoras adicionales para accesibilidad */
.option-card:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.option-card[style*="cursor: default"] {
  cursor: default !important;
}

/* Sombras suaves */
.v-card {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Estilos para campos de email editables */
.email-edit-field-mobile {
  flex: 1;
  max-width: calc(100% - 120px); /* Deja espacio para el botón de envío */
}

.email-edit-field-desktop-expanded {
  flex: 1;
  max-width: calc(100% - 80px); /* Deja espacio para el botón de envío */
  font-size: 0.75rem !important;
}

.email-edit-field-mobile .v-field,
.email-edit-field-desktop-expanded .v-field {
  border-radius: 6px !important;
  height: 32px !important;
  min-height: 32px !important;
}

.email-edit-field-mobile .v-field__input,
.email-edit-field-desktop-expanded .v-field__input {
  padding: 4px 8px !important;
  min-height: auto !important;
  font-size: inherit !important;
}

.email-edit-field-mobile .v-field__outline,
.email-edit-field-desktop-expanded .v-field__outline {
  --v-field-border-width: 1px;
}

/* Estilos para botones de editar email */
.v-btn.email-edit-btn {
  border: 1px solid rgba(25, 118, 210, 0.3) !important;
  border-radius: 50% !important;
  background-color: rgba(25, 118, 210, 0.05) !important;
  transition: all 0.2s ease !important;
}

.v-btn.email-edit-btn:hover {
  background-color: rgba(25, 118, 210, 0.1) !important;
  border-color: rgba(25, 118, 210, 0.5) !important;
  transform: scale(1.05);
}
</style>
